<!--
 * @Author: M.D.
 * @Date: 2020-01-02 13:27:48
 * @LastEditors: M.D.
 * @Description: 商品分类商品展示（含过滤）
 * @Remarks:
 -->
<template>
  <div class="gds-list-g-w">
    <div class="gds-list-out-w">
      <!-- 排序 -->
      <div class="glg-order-filter-w">
        <list-inner-filter @fVal="innerFilterChg"></list-inner-filter>
      </div>
      <!-- 列表 -->
      <div class="glg-order-w">
        <empty-list-default v-if="dataList.length === 0"></empty-list-default>
        <gds-list-row
          v-if="$route.name === 'qyfw'"
          :type="(outerFilter && outerFilter.topCateActIdx) || '1'"
          :gdsData="dataList"
        ></gds-list-row>
        <gds-list-grid
          v-if="$route.name !== 'qyfw'"
          :type="(outerFilter && outerFilter.topCateActIdx) || '1'"
          :gdsData="dataList"
        ></gds-list-grid>
      </div>
    </div>
    <!-- 分页 -->
    <div class="gds-l-g-page-w" v-if="dataList.length !== 0">
      <el-pagination
        class="gds-l-g-page"
        background
        @current-change="pageChg"
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import API from '@/api/api'
import ListInnerFilter from '@/components/list-inner-filter'
import GdsListGrid from '@/components/gds-list-grid'
import GdsListRow from '@/components/gds-list-row'

import { mapGetters } from 'vuex'

export default {
  props: {
    outerFilter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      innerFilter: null,
      curPage: 1,
      pageSize: 16,
      dataList: [],
      total: 10,
    }
  },
  computed: {
    ...mapGetters(['searchTxt']),
    validFilter() {
      return (
        !this._.isEmpty(this.outerFilter) && !this._.isEmpty(this.innerFilter)
      )
    },
  },
  created() {
    // this.getInitData()
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {
    outerFilter(v) {
      if (this.validFilter) {
        this.curPage = 1
        this.refreshDataByFilterChg() // init 执行
      }
    },
    innerFilter(v) {
      if (this.validFilter) {
        this.refreshDataByFilterChg()
      }
    },
    searchTxt(v) {
      if (this.validFilter) {
        this.curPage = 1
        setTimeout(() => {
          this.refreshDataByFilterChg()
        }, 800) // init 执行
      }
    },
  },
  methods: {
    // async getInitData () {
    //   const re = await API.getSPFLGoodsList({ areaCode: this.outerFilter.areaCateActIdx })
    //   console.log(re)
    // },
    innerFilterChg(newInFilter) {
      this.innerFilter = newInFilter
    },
    // watch filter update data
    async refreshDataByFilterChg() {
      // console.log('inner update', this._.find(this.innerFilter, { val: 1 }))
      // console.log('outer update', this.outerFilter)
      let re
      console.log('=========')
      console.log(this.outerFilter.topCateActIdx)
      if (this.outerFilter.topCateActIdx === '5') {
        re = await API.getVIPGoodsList(
          this.innerFilter,
          this.outerFilter,
          this.searchTxt,
          this.curPage,
          this.pageSize,
        )
      } else {
        re = await API.getSPFLGoodsList(
          this.innerFilter,
          this.outerFilter,
          this.searchTxt,
          this.curPage,
          this.pageSize,
        )
      }

      re.data.result.records = re.data.result.records.filter(a => {
        return a.id != '1635122958450065409'
      })
      this.dataList = re.data.result.records
      this.total = parseInt(re.data.result.total)
    },
    pageChg(newPg) {
      this.curPage = newPg
      this.refreshDataByFilterChg()
    },
  },
  components: {
    ListInnerFilter,
    GdsListGrid,
    GdsListRow,
  },
}
</script>

<style lang="stylus">
.gds-list-g-w {
  .gds-list-out-w {
    overflow: hidden;

    .glg-order-filter-w {

      margin-top: 10px;
      background-color: #ffffff;
	box-shadow: 0px 0px 20px 0px rgba(255, 122, 0, 0.15);
	border-radius: 8px;
    }
  }

  .gds-l-g-page-w {
    padding: 10px 0 30px;
   display: flex;
   justify-content: center;
    .gds-l-g-page {
      rightBottom();
    }
  }
}
</style>
